module.exports = __webpack_public_path__ + "img/mode1-6.d4aa5282.png";